import { render, staticRenderFns } from "./ClaimDetailsModal.vue?vue&type=template&id=0345f266&scoped=true"
import script from "./ClaimDetailsModal.vue?vue&type=script&lang=js"
export * from "./ClaimDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ClaimDetailsModal.vue?vue&type=style&index=0&id=0345f266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0345f266",
  null
  
)

export default component.exports